/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minor_Equal_Sloth_RiseInputs */

const fr_minor_equal_sloth_rise = /** @type {(inputs: Minor_Equal_Sloth_RiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement annulé`)
};

/**

* @param {Minor_Equal_Sloth_RiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const minor_equal_sloth_rise = /** @type {((inputs?: Minor_Equal_Sloth_RiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minor_Equal_Sloth_RiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_minor_equal_sloth_rise(inputs)
});